module.exports = __webpack_public_path__ + "img/image-12.a937e84c.jpg";